export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";